/**
 * Where an open ContextMenu sits, shared with its flyouts so they re-place
 * when the menu moves. Kept out of `context-menu.tsx` so that file exports
 * only components (fast refresh).
 */
import { createContext, useContext } from "react";

export interface MenuSpot {
  x: number;
  y: number;
}

export const ContextMenuPositionContext = createContext<MenuSpot>({
  x: 0,
  y: 0,
});

/** The open menu's placed top-left; a new object each time it moves. */
export function useContextMenuPosition(): MenuSpot {
  return useContext(ContextMenuPositionContext);
}

export function sameSpot(a: MenuSpot, b: MenuSpot): boolean {
  return a.x === b.x && a.y === b.y;
}
